export default Object.freeze([
    {
        brand: 'Edenhills',
        email: 'country@edenhills.com.au',
        url: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Edenhills%20Albury%20Tagging%20Guide_June.pdf'
    },
    {
        brand: 'Edenhills',
        email: 'support@edenhills.com.au',
        url: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Edenhills%20SA%20Tagging%20Guide_June.pdf'
    },
    {
        brand: 'Edenhills',
        email: 'care@edenhills.com.au',
        url: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Edenhills%20VIC%20Tagging%20Guide_June.pdf'
    },
    {
        brand: 'Lawnswood',
        email: 'care@lawnswood.com.au',
        url: 'https://familypetcare.s3-ap-southeast-2.amazonaws.com/TaggingGuides/Lawnswood%20Tagging%20Guide_June.pdf'
    },
    {
        brand: 'Pets at Peace CW',
        email: 'care@petsatpeacecw.com.au',
        url: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/NSW+P%26P-CW-tagging-guide.pdf'
    },
    {
        brand: 'Patch & Purr',
        email: 'info@patchandpurr.com.au',
        url: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/NSW+P%26P-MO-tagging-guide.pdf'
    },
    {
        brand: 'Pets in Peace',
        email: 'care@petsinpeace.com.au',
        url: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/PiP-tagging-guide.pdf'
    },
    // {
    //     brand: 'NSW P&P-SW',
    //     email: 'info@patchandpurr.com.au',
    //     url: 'https://familypetcare.s3.ap-southeast-2.amazonaws.com/TaggingGuides/NSW+P%26P-SW-tagging-guide.pdf'
    // },
]);
